var _defs, _path, _polygon, _rect, _rect2, _path2, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 163 61.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f2f2;stroke:#000;stroke-miterlimit:10;}.cls-2{fill:#009cdb;}.cls-3{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.23,59H16a5.19,5.19,0,0,1-5.18-5.18V7.39A5.18,5.18,0,0,1,16,2.21H160.09v.2Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "159.67 2.63 159.81 58.6 123.53 58.57 119.14 58.57 119.14 2.63 122.31 2.62 159.67 2.63"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 118.1,
    y: 2.63,
    width: 2.07,
    height: 55.95
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 124.61,
    y: 6.47,
    width: 7.42,
    height: 48.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132,56.15h-7.42a1,1,0,0,1-1-1V6.47a1,1,0,0,1,1-1H132a1,1,0,0,1,1,1V55.12A1,1,0,0,1,132,56.15Zm-6.38-2.07H131V7.51h-5.34Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 35,
    fill: "black",
    fontFamily: "OpenSans-Regular, Open Sans, sans-serif",
    fontSize: "9pt"
  }, "Back left")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackLeft);
export default __webpack_public_path__ + "static/media/back_left.536282043f8061112505556d229ce665.svg";
export { ForwardRef as ReactComponent };